var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86709 0.137458C5.78206 0.0522517 5.66663 0.00436856 5.54625 0.00436856C5.42588 0.00436856 5.31044 0.0522517 5.22541 0.137458L3 2.35832L0.77459 0.132907C0.659964 0.0182816 0.492894 -0.0264848 0.336312 0.0154711C0.179731 0.057427 0.057427 0.179731 0.0154711 0.336312C-0.0264848 0.492894 0.0182816 0.659964 0.132907 0.77459L2.35832 3L0.132907 5.22541C0.0182816 5.34004 -0.0264848 5.50711 0.0154711 5.66369C0.057427 5.82027 0.179731 5.94257 0.336312 5.98453C0.492894 6.02648 0.659964 5.98172 0.77459 5.86709L3 3.64168L5.22541 5.86709C5.34004 5.98172 5.50711 6.02648 5.66369 5.98453C5.82027 5.94257 5.94257 5.82027 5.98453 5.66369C6.02648 5.50711 5.98172 5.34004 5.86709 5.22541L3.64168 3L5.86709 0.77459C6.04003 0.601654 6.04003 0.310394 5.86709 0.137458Z",
    fill: "#3E4B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignCrossIcon);
export default __webpack_public_path__ + "static/media/campaign_cross_icon.7c45752bb3346873937a5080e8310e82.svg";
export { ForwardRef as ReactComponent };